import editPortfoliosReducer from '../state/edit-portfolio-slice'

export const portfoliosReducer = {
  editPortfolios: editPortfoliosReducer
}
